import * as React from "react";

export interface Option {
    value: string | number | string[];
    content: string | JSX.Element;
}

export interface SelectProps {
    value?: string | number | string[];
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    editing?: boolean;
    id?: string;
    className?: string;
    options?: Option[];
}

export const Select: React.FunctionComponent<SelectProps>  = (props: SelectProps) => {
    const valueOptionMapper = {};

    props.options.forEach((option) => {
        valueOptionMapper[option.value.toString()] = option;
    });

    const unEditedContent = (valueOptionMapper[props.value.toString()] || {}).content || null;

    return props.editing
        ? (
            <select value={props.value} onChange={props.onChange}>
                {props.options.map((option, key) => {
                    const content = typeof option.content === "string"
                        ? Capitalize(option.content)
                        : option.content;
                    return (
                        <option key={key} value={option.value}>
                            {content}
                        </option>
                    );
                })}
            </select>
        )
        : (
            <p id={props.id} className={props.className}>
                {typeof unEditedContent === "string"
                    ? Capitalize(unEditedContent)
                    : unEditedContent
                }
            </p>
        );
};

function Capitalize(str: string) {
    return str ? str[0].toUpperCase() + str.slice(1) : "";
}
